import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg4 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z M20.3247 25H16.8927V21.784H9.52469V18.712L16.0527 8.248H20.3247V19H22.4367V21.784H20.3247V25ZM16.6527 11.968L12.4047 19H16.8927V11.968H16.6527Z",
		fill: "currentColor"
	})
});
export default Svg4;
